/**
 * 分类占比组件
 * zxw
 * 2024-05-21
 */

import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import Pie from '@ant-design/plots/es/components/pie';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const IntersectionID = (props) => {
    const [mod, setMod] = useState('')
    const [data, setData] = useState([]);

    useEffect(()=>{
        /**
         * 根据mod获取路口统计报表数据
         * @param {*} mod 
         */
        const getData = (mod) => {
            const params = {
                'mod': mod,
            }
            $.ajax({
                url: `${CNF.api}report/intersections${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET',
                dataType: 'JSON',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length>0){
                            //  计算百分比
                            let t = 0;
                            for(let i=0; i<data.dat.length; i++){
                                t += data.dat[i].count;
                            }
                            let newData = data.dat;
                            for(let j=0; j<data.dat.length; j++){
                                let p = 100 * parseFloat(data.dat[j].count/t);
                                newData[j].type = data.dat[j].type;
                                newData[j].percent = p.toFixed(2);
                            }
                            setData(newData);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }
        if(props.mod !== mod){
            setMod(props.mod)
            getData(props.mod);
        }
    },[props.mod,mod]);

    const config = {
        data: data,
        width: winWidth-(props.collapsed?80:200)-50,
        angleField: 'count',
        colorField: 'type',
        radius: 0.8,
        percent: true,
        label: {
            text: (d) => `${d.type} ${d.percent}%`,
            position: 'outside',
            transform: [{ type: 'overlapDodgeY' }],
        },
        legend: {
            color: {
                title: false,
                position: 'top',
                rowPadding: 5,
            },
        },
        tooltip: {
            title: 'type',
            items: [
                { field: 'count', name: '数量', valueFormatter: (value) => `${value} 个`}, 
                { field: 'percent', name: '占比', color: 'red',valueFormatter: (value) => `${value} %`}],
        },
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: { opacity: 0.5 },
        },
    };
    return <>
        <div style={{ padding: '50px 25px',width: winWidth-(props&&props.collapsed?80:200) }}>
            <Pie width={'100%'} {...config} />
        </div>
    </>
}

export default IntersectionID;